// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 746 ? "pages-" : chunkId) + "." + {"47":"ee5c8645","342":"69167028","746":"15dc1616"}[chunkId] + ".chunk.js";
};